module.exports = __webpack_public_path__ + "img/villarreal-logo-icon.138dad2c.png";